import React, { useEffect, useState, useRef } from "react";
import { Card, Modal, Input, Button, message, Spin } from "antd";
import axios from "axios";
import SummaryApi from "../common/index";
import "../Styles/SellerStylings/UserSellerChat.css";

const { TextArea } = Input;

const UserSellerChat = ({ token }) => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [messages, setMessages] = useState([]);
  const [replyText, setReplyText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const chatEndRef = useRef(null);

  const fetchQueries = async () => {
    try {
      setLoading(true);
      const res = await axios.get(SummaryApi.getMyQueries.url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        withCredentials: true,
      });
      if (res.data.success) setQueries(res.data.queries);
    } catch (err) {
      message.error("Failed to load queries");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueries();
  }, []);

  const fetchMessages = async (query_id) => {
    try {
      const res = await axios.get(SummaryApi.getQueryMessages(query_id).url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.data.success) {
        setMessages(res.data.messages);
        setModalVisible(true);
        setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: "smooth" }), 300);
      }
    } catch (err) {
      message.error("Failed to load messages");
    }
  };

  const sendReply = async () => {
    if (!replyText.trim()) return message.warning("Reply cannot be empty");
    try {
      const res = await axios.post(
        SummaryApi.replyToSellerResponse.url,
        { query_id: selectedQuery.id, message: replyText },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      if (res.data.success) {
        message.success("Reply Sent!");
        setReplyText("");
        fetchMessages(selectedQuery.id);
      }
    } catch {
      message.error("Failed to send reply");
    }
  };

  if (loading) return <Spin tip="Loading..." style={{ marginTop: 50 }} />;

  return (
    <div className="userchat-container">
      <h2 className="chat-title">User Support Queries</h2>

      {queries.map((q) => (
        <Card
          key={q.id}
          className="query-card"
          title={q.subject}
          extra={
            <Button
              style={{background:"#1129ce",color:"white"}}
              onClick={() => {
                setSelectedQuery(q);
                fetchMessages(q.id);
              }}
            >
              Open Chat
            </Button>
          }
        >
          <p><strong>Category:</strong> {q.category}</p>
          <p><strong>Messages:</strong> {q.reply_count}</p>
        </Card>
      ))}

      {/* ✅ CHAT MODAL */}
      <Modal
        title={`Chat - ${selectedQuery?.subject}`}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={700}
        className="chat-modal"
      >
       {/* ✅ CHAT BODY */}
<div className="chat-body">
  {messages.map((msg) => (
    <div
      key={msg.id}
      className={`chat-message ${
        msg.sender_role === "customer" ? "user-msg" : "seller-msg"
      }`}
    >
      <div className="chat-bubble">
        <div className="chat-text">{msg.message}</div>
        <div className="chat-time">
          {new Date(msg.created_at).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </div>
    </div>
  ))}
  <div ref={chatEndRef}></div>
</div>



        <div className="chat-input-area">
          <TextArea
            
            rows={2}
            placeholder="Type your message..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
          />
          <Button type="primary" 
          style={{background:"#ee152d"}}
          onClick={sendReply}>
            Send
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default UserSellerChat;
